import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { RadioButton } from 'primeng/radiobutton';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ConsultationType } from '../appoinment-const/appoinment-enum';
import { AppoimentService } from '../appoinment-services/appoiment.service';

@Component({
  selector: 'patient-payment-summury',
  imports: [Button, RadioButton, CommonModule, FormsModule],
  templateUrl: './payment-summury.component.html',
  styleUrl: './payment-summury.component.css',
})
export class PaymentSummuryComponent {
  @Input() summaryData: any;

  private _appointmentService = inject(AppoimentService);
  private messageServices = inject(MessageService);
  private _router = inject(Router);

  ConsultationType = ConsultationType;

  paymentMode!: 'online' | 'cash';

  ngOnInit(): void {
    console.log(this.summaryData, 'payment summary data in summary component');
  }

  paymentModeMap: any = {
    online: 101,
    cash: 102,
  };

  payClick() {
    if (!this.paymentMode) return;

    const paymentPayload = {
      data: {
        payment_date: new Date().toISOString(),
        payment_method: this.paymentModeMap[this.paymentMode],
        amount: Number(this.summaryData?.doctorFee) ?? 0,
        user_id: this.summaryData?.userId,
        payment_type: 101, // 101 = appointment payment
        product_info: 'Consultation Booking',
        duration: 0,
      },
    };

    this._appointmentService.getPaymentId(paymentPayload).subscribe({
      next: (res) => {
        console.log(res);

        //currently we dont have payment id in response if new payment api ,
        const paymentId = res?.payment_id;

        if (paymentId && paymentId !== '') {
          this.confirmPayment(res);
        } else {
          console.error('Payment ID not found in response');
        }
      },
      error: (err) => {
        console.warn(err);
      },
    });
  }

  confirmPayment(res: any) {
    if (!res.payment_id) {
      return;
    }

    const paymentPayload = res;

    const payload = {
      appointment: {
        patient_id: this.summaryData?.PatientId ?? 'dummy-patient-id',
        doctor_id: this.summaryData?.doctorId ?? 'dummy-doctor-id',
        parent_appointment_id: null,
        payment_id: res.payment_id,
        slot_id: this.summaryData?.selectedSlotId ?? 'dummy-slot-id',
        pre_assessment_id: this.summaryData?.assessmentID ?? null,
        appointment_description: 'Consultation Booking',
        appointment_date: this.summaryData?.selectedDate
          ? new Date(this.summaryData.selectedDate).toISOString()
          : new Date().toISOString(),
        appointment_type: this.summaryData?.selectedType ?? 201,
        appointment_status: 101, // assuming 101 = booked
        followup_limit: 0,
        followup_duration: 0,
        amount: Number(this.summaryData?.doctorFee) ?? 0,
        payment_mode: this.paymentModeMap[this.paymentMode],
        isSubscription_booking: false,
      },
      reportUrl: this.summaryData?.reportUrl ?? '',
    };

    console.log('Final Payload:', payload);

    this._appointmentService.createAppointment(payload).subscribe({
      next: (res) => {
        console.log('Appointment Created:', res);
        if (this.paymentMode === 'cash') {
          this.messageServices.add({
            key: 'custom-toast',
            severity: 'success',
            summary: 'Appointment Created Successfully',
            detail: 'Your appointment has been created.',
          });
          // navigate to dashboard

          this._router.navigate(['/dashboard']);
        }
        if (this.paymentMode === 'online') {
          this.submitPayUForm(paymentPayload);
          //  this._router.navigate(['/dashboard']);
        }
      },
      error: (err) => {
        console.error(err);
        this.messageServices.add({
          key: 'custom-toast',
          severity: 'error',
          summary: 'Error Creating Appointment',
          detail: 'There was an error while creating your appointment. Please try again.',
        });
      },
    });
  }

  submitPayUForm(data: any) {
    const returnUrl = data.return_url;
    const payUAction = data.url + '_payment';

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = payUAction;
    form.target = '_blank';

    const fields = [
      'key',
      'txnid',
      'amount',
      'productinfo',
      'firstname',
      'email',
      'phone',
      'surl',
      'furl',
      'hash',
    ];

    fields.forEach((field) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field;

      if (field === 'surl' || field === 'furl') {
        input.value = returnUrl;
      } else if (data[field] !== undefined) {
        input.value = data[field];
      }
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
